module.exports = __webpack_public_path__ + "static/media/unattended-banner.eaf98431.jpg";